// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512081003/js/" + chunkId + "." + {"44":"ce406971","225":"7b8b9612","481":"86c046b4","486":"25a63505","770":"8850f3ee"}[chunkId] + ".0.6112374065361317.chunk.js";
};